import { compose } from 'recompose';
import HrSearch from './hrSearch';

const enhance = compose();
export default enhance(HrSearch);
